import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppThemeProvider } from './Theme/AppThemeProvider';
import './utils/localization/i18n';
import './utils/localization/language/authenticator-i18n';
import {
  GoldspotAuthConfig,
  AuthenticatorHOC,
} from '@goldspotdiscoveries/auth';
import { endpoints } from './app-endpoints';

import { LicenseInfo } from '@mui/x-license-pro';
import { CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { AppAlertProvider } from './Contexts/AppAlertContext';
LicenseInfo.setLicenseKey(
  '58f1614c420a139738af737e125265efTz01MDUyNCxFPTE2OTQyNzc2MTI0NzUsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
);

// initialize aws amplify config; pass array of endpoints if needed
GoldspotAuthConfig(endpoints);
const AuthenticateApp = AuthenticatorHOC(App);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <BrowserRouter>
        <AppAlertProvider>
          <CssBaseline />
          <AuthenticateApp />
        </AppAlertProvider>
      </BrowserRouter>
    </AppThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
